<script setup lang="ts">
import agentSm from "~/assets/icons/agent/agent-sm.svg?url"

const { state: myself } = useSelf()
const { sidebarRootsId } = useGlobals()
const { navigateToLatestOrNewConversation } = useNavigation()
const { isDragging } = useGestures()
</script>

<template>
  <sidebar-section>
    <template #default>
      <div :id="sidebarRootsId" class="roots">
        <sidebar-entry-file
          v-if="myself.home"
          fractional-index="fixme"
          :file="myself.home"
        />
        <sidebar-entry-file
          v-if="myself.archive"
          fractional-index="fixme"
          :file="myself.archive"
        />
        <div
          class="agent-button"
          :class="{ isDragging }"
          @click="navigateToLatestOrNewConversation()"
        >
          <div>
            <img :src="agentSm" class="agent-icon">
          </div>
          <div>
            Agent
          </div>
        </div>
      </div>
    </template>
  </sidebar-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.roots
  @apply flex flex-col gap-[#{$sidebar-gap-items-container}]

.agent-button
  @apply flex items-center gap-1.5
  @apply text-[#{$sidebar-t-item}] t-sidebar-item
  @apply -m-1.5 p-1.5 rounded-[#{$sidebar-br-item-hovered}]
  @apply cursor-pointer
  &:not(.isDragging):hover
    @apply bg-[#{$sidebar-bg-item-hovered}]

.agent-icon
  @apply w-6 h-6
</style>
